import { required, optional } from 'AppReact/schema';


export default {
    selectedFloorPlan: optional('integer'),
    selectedUnitNumber: optional('string'),
    moveInDate: required('jsDate'),
    hasError: optional('boolean'),
    selectedFloorPlanError: optional('string'),
    moveInDateError: optional('string'),
}


export const defaultMoveInData = {
    selectedFloorPlan: null,
    selectedUnitNumber: null,
    moveInDate: new Date(),
    hasError: false,
    selectedFloorPlanError: '',
    moveInDateError: '',
}
